// src/layouts/PublicLayout.jsx
import React from "react";
import Footer from "../components/Footer";
// Optional: If you have a public navbar
// import PublicNavbar from "../components/PublicNavbar";

function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      {/* Optional Navbar for public pages */}
      {/* <PublicNavbar /> */}

      <main className="flex-grow">
        {children}
      </main>

      <Footer />
    </div>
  );
}

export default PublicLayout;